import { useEffect, useState } from 'react';
import { handleMapToOptions } from '@/common/functions/handleMapToOptions';
import { DEFAULT_PRODUCT_STATUS } from '../constants/productStatusOptions';
import { getProductsByStatus } from '../helpers/getProductsByStatus';

export const useProductChartFilters = (products) => {
	const [productStatus, setProductStatus] = useState(DEFAULT_PRODUCT_STATUS);
	const [selectedProducts, setSelectedProducts] = useState([]);

	const productOptions = handleMapToOptions(
		getProductsByStatus(products, productStatus.value),
		'name',
		'_id',
	);

	const handleGetProducts = () => {
		if (!products?.length) {
			return;
		}

		setSelectedProducts(() =>
			handleMapToOptions(
				getProductsByStatus(products, productStatus.value),
				'name',
				'_id',
			),
		);
	};

	const handleSelectAll = () => {
		setSelectedProducts(() => productOptions);
	};

	const handleUnselectAll = () => {
		setSelectedProducts(() => []);
	};

	useEffect(() => {
		handleGetProducts();
	}, [productStatus, products]);

	return {
		productStatus,
		setProductStatus,
		selectedProducts,
		setSelectedProducts,
		productOptions,
		handleSelectAll,
		handleUnselectAll,
	};
};
